<template>

    <layout-default :hide-footer-mobile="true">
        <div class="container">

            <div class="backpack-page" v-if="studentsWithPrices.length">
                <div class="backpack-page-content">
                    <div class="backpack-title-container">

                        <div class="back-link d-flex align-items-center">
                            <img src="/images/iconos/flecha-izquierda.png" alt="">
                            <a href="#" class="underline-link underline-link--secondary" @click.prevent="$router.go(-1)">VOLVER</a>
                        </div>

                        <div class="backpack-title">
                            <img src="/images/iconos/Flecha-derecha.svg" alt="">
                            <h4 v-if="studentsWithPrices.length > 1">Tu mochila de compras ({{studentsWithPrices.length}} programas)</h4>

                            <h4 v-if="studentsWithPrices.length === 1">Tu mochila de compras</h4>
                        </div>

                        <div class="message-info-box message-info-box--alert">
                            <img src="/images/iconos/icon-alert-circle-red.svg" alt="">
                            <p>Los cupos de los cursos en tu Mochila de Compras pueden agotarse rápidamente.
                                Cómpralos pronto para que no pierdas los horarios que elegiste</p>
                        </div>
                    </div>

                    <div class="main-content">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="programs-list-selected">
                                    <div v-if="studentsWithPrices.length">
                                        <div v-for="(student, index) in studentsWithPrices" :key="index" class="program-selected">
                                            <div class="plan-selected-title" :class="{ 'plan-selected-title-red' :  student.program.name === 'Tradicional PSU 4° Medio', 'plan-selected-title-purple' :  student.program.name === 'Academia PSU Egresados'}">
                                                <span>Programa P.T</span>
                                                <h2>{{ student.program.name }}</h2>
                                            </div>

                                            <div class="price">
                                                <p>Monto programa {{index + 1}}</p>
                                                <span v-if="student.prices">{{ student.prices.precioTotal | moneyFormatter }}</span>
                                            </div>

                                            <p>Programa asociado al estudiante: <strong>{{ student.name }} {{student.fatherLastName}}</strong></p>

                                            <div class="delete-program">
                                                <a href="#" @click.prevent="removeStudent(student.id)" class="underline-link underline-link--secondary"><img src="/images/iconos/icon-delete.svg" alt=""> ELIMINAR PROGRAMA</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="abstract-check-in-info-cont">
                                    <abstract-check-in-info @buttonClicked="saveOrderData" :total="total"></abstract-check-in-info>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="backpack-page backpack-empty" v-else>
                <div class="backpack-page-content">
                    <div class="backpack-title-container">

                        <div class="back-link d-flex align-items-center">
                            <img src="/images/iconos/flecha-izquierda.png" alt="">
                            <a href="#" class="underline-link underline-link--secondary" @click.prevent="$router.go(-1)">VOLVER</a>
                        </div>

                        <div class="backpack-title">
                            <img src="/images/iconos/Flecha-derecha.svg" alt="">
                            <h4>Tu mochila de compras</h4>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col">
                            <div class="main-content-empty-backpack">
                                <img src="/images/iconos/mochila-vacia.png" alt="">
                                <h3>TU MOCHILA DE COMPRAS ESTÁ VACÍA</h3>
                                <p>Eliminaste los programas que habías seleccionado</p>

                                <div class="row justify-content-center">
                                    <div class="col-md-3 col-8">
                                        <router-link :to="{name: 'Landing'}" class="btn-pdv-primary w-100">ELIGE TU PROGRAMA</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </layout-default>


</template>

<script>

    import AbstractCheckInInfo from "@/components/AbstractCheckInInfo";
    import LayoutDefault from "@/layouts/Default"
    export default {
        data(){
            return {
                total: null
            }
        },

        computed:{
            studentsWithPrices(){
                return this.$store.state.studentsWithPrices
            },
            students(){
                return this.$store.state.students
            }

        },

        components: {
            AbstractCheckInInfo,
            LayoutDefault
        },

        methods:{

            removeStudent(studentId){
                this.$store.dispatch('removeStudent', studentId)
                    .then(()=>{
                        this.$store.dispatch('setStudentsWithPrices');
                        if(this.studentsWithPrices.length){
                            this.setTotal()
                        }else{
                            this.total = 0;
                            this.$store.dispatch('hideBackpack');
                        }
                    });

            },

            saveOrderData() {
                let fullOrderStudentsData = this.students.map(student => {
                    return {
                        locationId: student.selectedLocation.id,
                        programId: student.program.id,
                        coursesIds: student.selectedCourses.map(course => course.courseId),
                        studentId: student.id
                    }
                });

                this.$store.dispatch('addInfoToFullOrder', { orderDetails: fullOrderStudentsData })
                    .then(() => {
                        this.goToNextStep();
                    })
            },

            setTotal(){
                this.total = this.studentsWithPrices.map(student => student.prices.precioTotal).reduce((previousValue, currentValue) => previousValue + currentValue);
            },

            goToNextStep(){
                this.$router.push({name: 'Step4'});
            }
        },

        mounted() {

            if(this.studentsWithPrices.length){
                this.setTotal()
            }
        }


    }
</script>

<style scoped lang="scss">
    .backpack-page{
        padding-top: 95px;
        .back-link{
            margin-bottom: 15px;
            img{
                width: 15px;
                margin-right: 3px;
            }
            a{
                font-size: 13px;
            }
        }

        .backpack-page-content{
            border: none;
            box-shadow: none;
            padding: 0;
            .backpack-title-container{
                .backpack-title{
                    display: flex;
                    align-items: center;
                    margin-bottom: 11px;
                    img{
                        margin-right: 5px;
                    }
                    h4{
                        font-size: 18px;
                        line-height: 21px;
                        margin-bottom: 0;
                        @include alternative-regular;
                    }

                }
                .message-info-box{
                    align-items: center;
                    padding: 12px 16px;
                    img{
                        margin-right: 15px;
                    }
                    P{
                        margin-bottom: 0;
                    }
                    @include media-breakpoint-down(sm){
                        margin: 0 -15px;
                    }
                }
            }
            .main-content{
                .programs-list-selected{
                    .program-selected{
                        padding: 25px 0;
                        .sub-title{
                            color: #fff;
                            font-size: 13.6px;
                            letter-spacing: 3.4px;
                            line-height: 13px;
                            padding: 2px 5px;
                        }
                        h3{
                            font-size: 18.7px;
                            line-height: 30px;
                            font-weight: 900;
                        }
                        .price{
                            display: flex;
                            align-items: center;
                            p{
                                margin-bottom: 0;
                                margin-right: 10px;
                                font-size: 16px;
                                line-height: 18px;
                                @include alternative-medium-regular;
                            }
                            span{
                                font-size: 20px;
                                @include alternative-bold;
                                line-height: 23px;
                            }
                        }

                        p{
                            font-size: 14px;
                            @include alternative-light-regular;
                        }
                        .delete-program{
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 5px;
                            }
                        }
                    }
                }

                .abstract-check-in-info-cont{
                    position: relative;
                    margin: 25px 0;
                }

                @include media-breakpoint-down(sm){
                    padding-bottom: 160px;
                }
            }
        }

        &.backpack-empty{
            padding-bottom: 130px;
            .backpack-title{
                margin-bottom: 28px;
            }
            .main-content-empty-backpack{
                text-align: center;

                img{
                    width: 183px;
                    margin-bottom: 28px;
                }
                h3{
                    font-size: 16px;
                    line-height: 23px;
                    @include alternative-bold;
                }
                p{
                    font-size: 16px;
                    line-height: 24px;
                    margin-bottom: 16px;
                    @include alternative-medium-regular;
                }
            }
        }
    }
    .plan-selected-title{
        span{
            letter-spacing: 3.4px;
            font-size: 13.6px;
            padding: 3px 6px;
            color: gray;
            @include media-breakpoint-down(sm){
                font-size: 10px;
                padding: 2px 5px;
            }
        }
        h2{
            font-size: 18.7px;
            line-height: 30px;
            margin-bottom: 0;
            text-transform: uppercase;
            @include font-black-regular;
            color: $red-2-light;
            @include media-breakpoint-down(sm){
                font-size: 12.5px;
                line-height: 14px;

            }
        }
        &.plan-selected-title-red{
            span{
                background: $red-light;
            }

            h2{
                color: $red-2-light;
            }

        }

        &.plan-selected-title-purple{
            span{
                background: $purple-light;
            }

            h2{
                color: $purple;
            }

        }

    }

</style>